module.exports = __webpack_public_path__ + "static/media/provider-awcmsevenmojos.215e2136.png";